export default __webpack_public_path__ + "static/media/The Weight of Sin.71d4936c.png";